/* tslint:disable */
/* eslint-disable */
/**
 * Appli métier
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: Yoda 1 & 2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "../configuration"
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from "axios"
import globalAxios from "axios"
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded
} from "../common"
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap
} from "../base"
/**
 * TvaResourceApi - axios parameter creator
 */
export const TvaResourceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get TVA configuration table
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    get: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/tva`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * TvaResourceApi - functional programming interface
 */
export const TvaResourceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = TvaResourceApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Get TVA configuration table
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async get(
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<number>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.get(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["TvaResourceApi.get"]?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * TvaResourceApi - factory interface
 */
export const TvaResourceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = TvaResourceApiFp(configuration)
  return {
    /**
     *
     * @summary Get TVA configuration table
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    get(options?: RawAxiosRequestConfig): AxiosPromise<Array<number>> {
      return localVarFp.get(options).then(request => request(axios, basePath))
    }
  }
}

/**
 * TvaResourceApi - object-oriented interface
 */
export class TvaResourceApi extends BaseAPI {
  /**
   *
   * @summary Get TVA configuration table
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public get(options?: RawAxiosRequestConfig) {
    return TvaResourceApiFp(this.configuration)
      .get(options)
      .then(request => request(this.axios, this.basePath))
  }
}
